/***
 *Â @FileName:
 *Â @Author: manyao.zhu
 *Â @Date: 2020-06-11 17:22:53
 */
export const MENU_CONFIG = [
  {
    router: '/pages/chat',
    title: 'ä¼è¯',
    icon: 'message',
    iconType: 'fill',
  },
  {
    router: '/pages/contacts',
    title: 'èç³»äºº',
    icon: 'contacts',
    iconType: 'fill',
  },
  {
    router: '/pages/calendar',
    title: 'æ¥å',
    icon: 'calendar',
    iconType: 'fill',
  },
  {
    router: '/pages/application',
    title: 'åºç¨',
    icon: 'appstore',
    iconType: 'fill',
  },
  {
    router: '/pages/collection',
    title: 'æ¶è',
    icon: 'star',
    iconType: 'fill',
  },
];
